import Party from "./Party";

interface BankTransaction {
    txId: string;
    txType: TxType;
    txDate: Date;

    subFamilyId: string;
    description: string;

    creditorName: string;
    creditorIban: string;

    debtorName: string;
    debtorIban: string;

    amount: string;
    currency: string;
}

export enum TxType {
    CRDT = "CRDT",
    DBIT = "DBIT",
}

export enum MatchingResultType {
    GL_RULE = "GL_RULE",
    SALES_INVOICE = "SALES_INVOICE",
    PURCHASE_INVOICE = "PURCHASE_INVOICE",
    INVOICE_MISSING = "INVOICE_MISSING",
    NOT_MATCHED = "NOT_MATCHED",
    WAS_SENT = "WAS_SENT",
    MULTI_MATCH_INVOICE = "MULTI_MATCH_INVOICE",
}

export enum TransactionSentType {
    MARKED_AS_SENT = "MARKED_AS_SENT",
    SENT_TO_MERIT = "SENT_TO_MERIT"
}

export interface BaseMatchedTransaction {
    tx: BankTransaction;
    type: MatchingResultType;
}

export interface InvoiceTransaction extends BaseMatchedTransaction {
    invoiceId: string[]
    paymentMethod: string

    multiPayments?: any //Map<String, number>
    multipleInvoiceMatchedInconsistency?: boolean;

    //for debug
    party?: Party;
    invoiceData?: string;
}

export interface GlTransaction extends BaseMatchedTransaction {
    accountCodeDebit: string;
    accountCodeCredit: string;
}

interface MatchedDocument {
    iban: string;
    currency: string;
    fromDate: string;
    toDate: string;
    transactions: BaseMatchedTransaction[];
}

export default MatchedDocument;